// The trait breakdown an answer row expands into: one row per trait value, with its count and its
// share of that answer -- a fixed pair, unlike the shelf / ecommerce and menu-test breakdowns, whose
// columns follow the view mode. Every view that splits a row this way builds it here.

import { encodeLabel, formatAmounts } from '@aytm/app/stats/lib/util/helpers'
import { colorIndexOf } from '@aytm/app/stats/page/question-views/components/lib/color-index'

export const calcTraitTable = ({ id, trait, traitName, traitValues, traitAnswer, answerPosition }) => ({
  id: `${id}-traits`,
  cols: [
    {
      type: 'title',
      title: encodeLabel(
        (Object.hasOwn(trait, 'title') && trait.title) ||
          (Object.hasOwn(trait, 'id') && traitName.toUpperCase()) ||
          traitName
      )
    },
    // the share names itself where the % marker would sit; the column heads no count slot of its own
    { type: 'progress', title: '', percentLabel: '% of this answer', format: value => formatAmounts(value) }
  ],
  rows: traitValues.map((value, index) => ({
    cells: [
      { title: value.name.en || value.name, colorIndex: colorIndexOf(index + 1) },
      { amount: traitAnswer[value.id]?.amount || 0, percents: traitAnswer[value.id]?.percents || 0 }
    ],
    position: index + 1,
    // the chart draws this value as one segment of the answer's own column, and the two find each
    // other by name -- the row's own position numbers the trait value, not the answer
    ...(null == answerPosition ? {} : { pointId: `a${answerPosition}t${index + 1}` })
  })),
  classNames: ['child']
})
